import { render, staticRenderFns } from "./EditControlSettingsForm.vue?vue&type=template&id=68955e3a&"
import script from "./EditControlSettingsForm.vue?vue&type=script&lang=js&"
export * from "./EditControlSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports